import React, { PropTypes } from 'react';
import { pointIcon } from '../reducers/point';

const styles = point => {
  return {
    display: 'inline-block',
  };
};

const PointDragPreview = ({ point, taskType }) => (
  <div style={styles(point)}>
    <img src={pointIcon(point, taskType)} alt="Point" />
  </div>
);

PointDragPreview.propTypes = {
  point: PropTypes.object.isRequired,
  taskType: PropTypes.string.isRequired,
};

export default PointDragPreview;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/components/PointDragPreview.js